const suggestions = [
  "What is the leave accrual policy?",
  "Is there any special policy for pilots?",
  "What benefits do contract employees get?",
  "How many work-from-home days are allowed?"
];

export default function SuggestedQuestions({ onSelect }) {
  return (
    <div className="suggested">
      {suggestions.map((q, i) => (
        <button key={i} onClick={() => onSelect(q)}>{q}</button>
      ))}
    </div>
  );
}
